<script setup lang="ts">
import ModalContent from '@zyro-inc/site-modules/components/ecommerce/modals/partials/ModalContent.vue';
import ModalLayout from '@zyro-inc/site-modules/components/ecommerce/modals/partials/ModalLayout.vue';
import { useEcommerceModal } from '@zyro-inc/site-modules/components/ecommerce/modals/useEcommerceModal';

defineProps<{
	translations: Record<string, string>;
}>();

const { closeEcommerceModal } = useEcommerceModal();
</script>

<template>
	<ModalLayout ref="modal">
		<ModalContent
			qa-selector="outofstock"
			:title="translations.checkoutModalOutOfStock"
			:text="translations.checkoutModalTryOrChoose"
			:button-text="translations.gotIt"
			@handle-close="closeEcommerceModal"
		/>
	</ModalLayout>
</template>
